import { GRANTED_FPS } from "../constants";

export const countExtraFrames = (actualFrameCount: number, RequiredLength: number) => {
    const extraFrames = actualFrameCount - (RequiredLength * GRANTED_FPS);
    return extraFrames;
}